// extracted by mini-css-extract-plugin
module.exports = {"container":"UnderContructionSection_container__2lUaV","image":"UnderContructionSection_image__2qVm3","title":"UnderContructionSection_title__2NHVK"};